import classNames from 'classnames'
import moment from 'moment'
import type { TileArgs } from 'react-calendar'

export function formCalendarTileClassName({ date, view }: TileArgs): string {
  const isDayView = view === `month`
  return classNames(`form-calendar-picker`, {
    [`aspect-square`]: isDayView,
    [`py-2`]: !isDayView,
    [`underline underline-offset-4`]: isDayView && moment(date).startOf(`d`).isSame(moment().startOf(`d`)),
  })
}
